import React from 'react'

import {
  styled, keyframes, rem
} from 'config/stitches.config'

const shimmer = keyframes({
  '0%': { backgroundPosition: '-200% 0' },
  '100%': { backgroundPosition: '200% 0' },
})

const SkeletonBlock = styled('div', {
  backgroundColor: '#e0e0e0',
  borderRadius: rem(4),
  backgroundImage: 'linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)',
  backgroundSize: '200% 100%',
  animation: `${shimmer} 1.5s ease-in-out infinite`,
})

const StyledSkeletonCard = styled('div', {
  borderTop: '1px solid $black',
  paddingY: rem(24),
  '@md': { paddingY: rem(32) },
  '&:last-child': { paddingBottom: 0 },
})

const StyledSkeletonContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  rowGap: rem(48),
  width: '100%',
  '@md': { flexDirection: 'row' },
})

const StyledSkeletonContent = styled('div', {
  textAlign: 'left',
  width: '100%',
  '@md': {
    flexBasis: '50%',
    flexShrink: 0,
    paddingRight: rem(80),
  },
})

const StyledSkeletonImage = styled(SkeletonBlock, {
  width: '100%',
  aspectRatio: '343 / 240',
  borderRadius: rem(8),
  '@md': {
    aspectRatio: '432 / 140',
    flexBasis: '50%',
  },
})

const NewsPreviewSkeleton = ({ count = 3 }) => (
  <>
    {Array.from({ length: count }).map((_, idx) => (
      <StyledSkeletonCard key={idx}>
        <StyledSkeletonContainer>
          <StyledSkeletonContent>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              marginBottom: '1rem',
            }}>
              <SkeletonBlock css={{
                width: rem(120),
                height: rem(20),
              }} />
              <SkeletonBlock css={{
                width: rem(100),
                height: rem(32),
                borderRadius: rem(32),
              }} />
            </div>
            <SkeletonBlock css={{
              width: '90%',
              height: rem(28),
              marginBottom: rem(8),
            }} />
            <SkeletonBlock css={{
              width: '60%',
              height: rem(28),
            }} />
          </StyledSkeletonContent>
          <StyledSkeletonImage />
        </StyledSkeletonContainer>
      </StyledSkeletonCard>
    ))}
  </>
)

export default NewsPreviewSkeleton
